<template>
    <div>
        <el-input
            :placeholder="placeholder"
            :disabled="disabled"
            v-model="name"
            @blur="updateName"
            size="small"
        >
            <el-button slot="append" icon="el-icon-search" :disabled="disabled" @click="openDialog()"></el-button>
        </el-input>

        <el-dialog
            title="链接选择器"
            :close-on-click-modal="false"
            :append-to-body="true"
            width="800px"
            top="10vh"
            :visible.sync="dialogVisible"
            :before-close="cloesDialog"
        >
            <div class="dialogContent">
                <div class="btnList">
                    <div class="btnItem" v-for="(item,index) in appPageTypeEnumList" :key="index" @click="tabPageTab(item.key)" :class="{'active' : item.key == queryForm.pageType && isAppPgae}">
                        <span>{{ item.value }}</span>
                    </div>
                    <div class="btnItem" @click="checkedId(4)" :class="{'active' : activeIndex == 4 && !isAppPgae}">
                        <span>活动页面</span>
                    </div>
                    <div class="btnItem" @click="checkedId(1)" :class="{'active' : activeIndex == 1 && !isAppPgae}">
                        <span>装修页面</span>
                    </div>
                    <div class="btnItem" @click="checkedId(5)" :class="{'active' : activeIndex == 5 && !isAppPgae}">
                        <span>商品分类</span>
                    </div>
                    <div class="btnItem" @click="checkedId(2)" :class="{'active' : activeIndex == 2 && !isAppPgae}">
                        <span>商品详情</span>
                    </div>
                    <div class="btnItem" @click="checkedId(3)" :class="{'active' : activeIndex == 3 && !isAppPgae}">
                        <span>文章详情</span>
                    </div>
                <!--例-->
                    <!--<div class="btnItem" @click="checkedId(2)" :class="{'active' : activeIndex == 2 && !isAppPgae}">-->
                        <!--<span>商品详情</span>-->
                    <!--</div>-->
                </div>

                <!--选择页面-->
                <div class="pathTab" v-if="isAppPgae">
                    <el-table
                        :data="appPageList"
                        row-key="id"
                        border
                        height="100%"
                    >
                        <el-table-column
                            align="center"
                            prop="pageName"
                            label="页面名称"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="pageLink"
                            label="链接"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            label="操作"
                            width="60"
                        >
                            <template slot-scope="scop">
                                <el-button type="text" size="mini" @click="onSubmit(scop.row)">选择</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination-box">
                        <el-pagination
                            @size-change="sizeChange"
                            @current-change="currentChange"
                            :current-page.sync="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalNum"
                            background
                            :pager-count="7"
                        >
                        </el-pagination>
                    </div>
                </div>

                <!--选择id-->
                <div class="pathTab" v-else>
                    <div class="serch">
                        <el-form :model="queryForm" label-width="80px" :inline="true">
                            <el-form-item label="名称" prop="searchContent">
                                <el-input style='width: 200px' size="small" clearable v-model="queryForm.searchContent"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="btn">
                            <el-button type="primary" size="small" @click="searchData">搜索</el-button>
                            <el-button type="primary" size="small" @click="resetData">重置</el-button>
                        </div>
                    </div>
                    <el-table
                        :data="dataList"
                        row-key="id"
                        border
                        height="580"
                    >
                        <el-table-column
                            align="center"
                            label="图片"
                            v-if="activeIndex === 2"
                        >
                            <template slot-scope='scope'>
                                <el-image
                                    @click='updateSrcList(scope.row.productPic)'
                                    style='width: 80px; height: 80px'
                                    :src='scope.row.productPic'
                                    :preview-src-list='srcList'
                                ></el-image>
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="center"
                            label="图片"
                            v-if="activeIndex === 4"
                        >
                            <template slot-scope='scope'>
                                <el-image
                                    @click='updateSrcList(scope.row.activityPic)'
                                    style='width: 80px; height: 80px'
                                    :src="scope.row.activityPic"
                                    :preview-src-list='srcList'
                                ></el-image>
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="center"
                            label="图片"
                            v-if="activeIndex === 5"
                        >
                            <template slot-scope='scope'>
                                <el-image
                                    @click='updateSrcList(scope.row.categoryPic)'
                                    style='width: 80px; height: 80px'
                                    :src="scope.row.categoryPic"
                                    :preview-src-list='srcList'
                                ></el-image>
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="center"
                            :prop="fieldOne"
                            :label="fieldOneName"
                            v-if="activeIndex !== 5 && activeIndex !== 4 && activeIndex !== 2"
                        >
                        </el-table-column>

                        <el-table-column
                            align="center"
                            :prop="fieldTwo"
                            :label="fieldTwoName"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            label="操作"
                            width="60"
                        >
                            <template slot-scope="scop">
                                <el-button type="text" size="mini" @click="onSubmit(scop.row)">选择</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination-box">
                        <el-pagination
                            @size-change="sizeChange"
                            @current-change="currentChange"
                            :current-page.sync="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalNum"
                            background
                            :pager-count="7"
                        >
                        </el-pagination>
                    </div>
                </div>
            </div>
<!--            <div-->
<!--                slot="footer"-->
<!--                class="flex justify-end"-->
<!--            >-->
<!--                <el-button @click="cloesDialog">关闭</el-button>-->
<!--                <el-button-->
<!--                    type="primary"-->
<!--                    @click="onSubmit"-->
<!--                >确定</el-button>-->
<!--            </div>-->
        </el-dialog>
    </div>
</template>

<script>
import { get } from '@/utils/request.js';
export default  {
    props: {
        placeholder: {
            type: String,
            default: '请输选择'
        },
        value: {
            type: String,
            default: ''
        },
        disabled:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            srcList: [''],//大图预览

            dialogVisible: false,
            appPageTypeEnumList: [],
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            name: '',
            appPageList: [],
            queryForm:{
                pageType: '',
                searchContent: '',
            },

            // 非枚举的分类
            isAppPgae: true, // 区别是否是枚举的分类
            activeIndex: 1, // 非枚举分类的点击样式
            dataList: [], // 列表数据
            findListUrl: '', // 请求数据的url
            fieldOneName: '', // 字段名称
            fieldOne: '', // 字段值
            fieldTwoName: '', // 字段名称
            fieldTwo: '',// 字段值
            pagePath: '', // 选择的路径
            fieldSearch : '', // 搜索字段
            fieldSearchName: '', // 搜索字段名称
        };
    },
    watch: {
        value:{
            handler(newValue){
                this.name = newValue
            },
            deep: true,
        }
    },
    created() {
        this.resetting();
        this.getAppPageTypeEnum();
        this.getAppPageList();
    },
    mounted() {
        this.$nextTick(()=>{
            this.name = this.value
        })
    },
    methods: {
        openDialog() {
            this.dialogVisible = true;
        },
        cloesDialog() {
            this.dialogVisible = false;
        },
        onSubmit(item) {
            console.log(item)
            if(this.isAppPgae){
                this.$emit('change',item.pageLink)
            } else {
                if(this.findListUrl == "/shop/productcategory/findList"){
                    this.$emit('change',`${this.pagePath}?cid=${item.id}`)
                }else{
                    this.$emit('change',`${this.pagePath}?id=${item.id}`)
                }
            }
            this.dialogVisible = false
        },
        updateName(){
            this.$emit('change',this.name)
        },
        sizeChange(size) {
            this.pageSize = size;
        },
        currentChange(page) {
            this.currentPage = page;
            if(this.isAppPgae){
                this.getAppPageList();
            } else {
                this.findListData();
            }

        },
        tabPageTab(type){
            this.queryForm.pageType = type;
            this.getAppPageList();
            this.isAppPgae = true;
        },
        resetting(){
            this.appPageTypeEnumList = [{
                key: '',
                value: '全部'
            }]
            this.pageSize = 10
            this.currentPage = 1
            this.queryForm = {
                pageType: '',
            }
        },

        // 获取app菜单枚举
        getAppPageTypeEnum(){
            get('/mpp/utils/getEnum',{
                enumType: 'app_page_type_shop'
            }).then((res)=>{
                if(res.success){
                    res.enumList.forEach((item)=>{
                        this.appPageTypeEnumList.push(item)
                    })
                }
            })
        },

        // 获取list
        getAppPageList(){
            get('/mpp/apppage/findList',{
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res)=>{
                if(res.success){
                    this.appPageList = res.page.list
                    this.totalNum = res.page.total;
                }
            })
        },

        /**
         *  左侧菜单由枚举和额外的id选择组成，枚举分类从服务端添加的，id选择部分在下方 checkedID()方法中的switch中添加配置，在上方的DOM里添加对应的菜单（见例）
         */


        // id选择
        checkedId(type){

            this.activeIndex = type;
            this.isAppPgae = false;
            this.currentPage = 1;
            this.totalNum = 0;
            this.dataList = [];
            this.findListUrl = '';
            this.pagePath = '';
            this.fieldOneName = '';
            this.fieldOne = '';
            this.fieldTwoName = '';
            this.fieldTwo = '';
            this.fieldSearch = '';
            this.fieldSearchName = '';
            switch (type) {
                case 1:
                    // 装修
                    this.findListUrl = '/mpp/appdecor/findList';
                    this.pagePath = '/pages/Page/Page'
                    this.fieldOneName = '模板名称';
                    this.fieldOne = 'decorName';
                    this.fieldTwoName = '模板备注';
                    this.fieldTwo = 'remarks';
                    this.fieldSearch = 'decorName';
                    this.fieldSearchName = '模板名称';
                    break;
                case 2:
                    // 商品
                    this.findListUrl = '/shop/product/findList'
                    this.pagePath = '/pages/Home/ProductDetail'
                    this.fieldOneName = '商品图片';
                    this.fieldOne = 'productPic';
                    this.fieldTwoName = '商品名称';
                    this.fieldTwo = 'productName';
                    this.fieldSearch = 'productName';
                    this.fieldSearchName = '商品名称';
                    break;
                case 3:
                    // 文章
                    this.findListUrl = '/cms/article/findList'
                    this.pagePath = '/pages/Home/NewsDetail'
                    this.fieldOneName = '文章名称';
                    this.fieldOne = 'articleName';
                    this.fieldTwoName = '文章内容';
                    this.fieldTwo = 'articleSummary';
                    this.fieldSearch = 'articleName';
                    this.fieldSearchName = '文章名称';
                    break;
                case 4:
                    // 活动
                    this.findListUrl = '/shop/activity/findList'
                    this.pagePath = '/pagesB/ActivityProduct/index'
                    this.fieldOneName = '活动图片';
                    this.fieldOne = 'activityPic';
                    this.fieldTwoName = '活动名称';
                    this.fieldTwo = 'activityName';
                    this.fieldSearch = 'activityName';
                    this.fieldSearchName = '活动名称';
                    break;
                case 5:
                    this.findListUrl = '/shop/productcategory/findList'
                    this.pagePath = '/pages/ProductList/ProductList'
                    this.fieldOneName = '分类图片';
                    this.fieldOne = 'categoryPic';
                    this.fieldTwoName = '分类名称';
                    this.fieldTwo = 'categoryName';
                    this.fieldSearch = 'categoryName';
                    this.fieldSearchName = '分类名称';
                    break;
                // 例
                // case 99:
                //     this.findListUrl = '这里里填列表的findlist接口地址，如/shop/product/findList'
                //     this.pagePath = '这里是前台对应的页面地址，不用带参数，如/pagesA/ProductDetail/ProductDetail'
                //     this.fieldOneName = '这里是字段描述，如商品图片';
                //     this.fieldOne = '这里是字段的名称，如productPic';
                //     this.fieldTwoName = '这里是字段描述，如商品名称';
                //     this.fieldTwo = '这里是字段的名称，如productName';
                //     this.fieldSearch = '这里是搜索字段的名称，如productName';
                //     this.fieldSearchName = '这里是搜索字段的描述，如商品名称';
                //     break;
            }

            this.findListData()
        },
        findListData(){
            let obj = {};
            obj[this.fieldSearch] = this.queryForm.searchContent;
            get(this.findListUrl,{
                ...obj,
                pageNum: this.currentPage,
                pageSize: 10,
            }).then((res)=>{
                if(res.success){
                    this.dataList = res.page.list;
                    this.totalNum = res.page.total;
                    console.log(this.fieldTwo, this.fieldOne)
                    this.$forceUpdate()
                }
            })
        },
        searchData(){
            this.currentPage = 1;
            this.findListData();
        },
        resetData(){
            this.queryForm.searchContent = "";
            this.currentPage = 1;
            this.findListData();
        },
        // 查看商品大图
        updateSrcList(src) {
            this.srcList[0] = src;
        },
    }
};
</script>

<style lang="scss" scoped>
    .dialogContent{
        height: 693px;
        display: flex;
        border-top: 1px solid #dcdfe6;
        .btnList{
            width: 160px;
            height: 100%;
            padding: 15px 0;
            border-right: 1px solid #dcdfe6;
            display: flex;
            flex-direction: column;
            .btnItem{
                width: 100%;
                height: 34px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                &:hover{
                    background-color: #ecf5ff;
                }
            }
            .active{
                background-color: #ecf5ff;
            }
        }
        .pathTab{
            flex: 1;
            width: 500px;
            height: calc(100% - 62px);

            .serch{
                padding: 10px 10px 0;
                width: 100%;
                height: 50px;
                display: flex;
                flex-direction: row;
            }
            .btn{
                margin-left: 10px;
                display: flex;
                align-items: center;
            }
        }
    }
</style>
